import React, { useContext } from 'react';
import { IPrismicImage } from '@lib/prismic/types';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import breakpoints from '@constants/breakpoints';

import { useTheme } from '@components/theme';
import classNames from 'classnames';
import UserContext from '@context/User/user-context';
import styles from './StyleQuiz.module.scss';

interface IStyleQuizProps {
    ctaUrl: string;
    ctaText: string;
    loggedInCtaUrl?: string;
    description: string;
    eyebrow: string;
    image: IPrismicImage;
    title: string;
}

const StyleQuiz = ({
  ctaUrl,
  ctaText,
  loggedInCtaUrl,
  description,
  eyebrow,
  image,
  title,
}: IStyleQuizProps) => {
  const theme = useTheme();
  const { user } = useContext(UserContext);

  return (
    <div className={classNames(styles.Wrapper, theme.styles.Section, theme.styles.Core4)}>
      <PrismicImage
        className={styles.Image}
        image={image}
        breakpoints={{
          mobile: breakpoints.tablet
        }}
      />
      <div className={styles.TextWrapper}>
        <div className={classNames(styles.Eyebrow, styles.Overline)}>{eyebrow}</div>
        <div className={classNames(theme.styles.Header, styles.Title)}>{title}</div>
        <div className={classNames(styles.Description, theme.styles.Title2)}>{description}</div>
        <div className={styles.CTAWrapper}>
          <a
            type="button"
            href={user && loggedInCtaUrl ? loggedInCtaUrl : ctaUrl}
            className={classNames(
              styles.Conflicting,
              theme.styles.Button,
              theme.styles.Primary
            )}
          >
            {ctaText}
          </a>
        </div>
      </div>
    </div>
  );
};

export default StyleQuiz;
